// extracted by mini-css-extract-plugin
export default {"phoneContainer":"Phone_phoneContainer__f7aDg","bgImagePhone":"Phone_bgImagePhone__Bi3s9","phoneImage":"Phone_phoneImage__CcctR"};